import { graphql } from "gql";

const MESSAGE_THREAD_SUMMARY_QUERY = graphql(`
  query MessageThreadSummary($input: MessageThreadSummaryInput!) {
    messageThreadSummary(input: $input)
  }
`);

export default MESSAGE_THREAD_SUMMARY_QUERY;
